<template>
  <div>
    <div class="d-flex align-center mb-6">
      <p class="text-2xl mb-0">Configuration des sources</p>
    </div>

    <v-card>
      <v-card-title>
        <span>Paramètres des sources pour la génération de présentations</span>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-form ref="settingsForm">
          <v-row>
            <!-- OneNext Global (BRAND) -->
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                ACPM OneNext Global (BRAND)
              </p>
              <p class="caption grey--text mb-2">
                Utilisé dans: Template 1
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="settings.onenext_global_year"
                label="Année"
                placeholder="2025"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="settings.onenext_global_semester"
                :items="semesters"
                label="Semestre"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>

            <!-- OneNext (PRINT lecteurs) -->
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                ACPM OneNext (PRINT lecteurs)
              </p>
              <p class="caption grey--text mb-2">
                Utilisé dans: Template 1, Template 2
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="settings.onenext_year"
                label="Année"
                placeholder="2025"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="settings.onenext_semester"
                :items="semesters"
                label="Semestre"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>

            <!-- OJD DFP (PRINT exemplaires) -->
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                ACPM OJD DFP (PRINT exemplaires)
              </p>
              <p class="caption grey--text mb-2">
                Utilisé dans: Template 1, Template 2, Template 4
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="settings.ojd_dfp_year_range"
                label="Période"
                placeholder="2024-2025"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>

            <!-- Kolsquare -->
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                {{ SOCIAL_SOURCE_LABEL }} (SOCIAL)
              </p>
              <p class="caption grey--text mb-2">
                Utilisé dans: Template 1, Template 2, Template 3, Template 4
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="settings.social_index_month"
                label="Mois et année"
                placeholder="novembre 2025"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>

            <!-- Newsletter (Editeur) -->
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                Editeur (NEWSLETTER)
              </p>
              <p class="caption grey--text mb-2">
                Utilisé dans: Template 1, Template 2, Template 3
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="settings.newsletter_month"
                label="Mois et année"
                placeholder="octobre 2025"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12"><v-divider></v-divider></v-col>

            <!-- Podcast (Editeur) -->
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                Editeur (PODCAST)
              </p>
              <p class="caption grey--text mb-2">
                Utilisé dans: Template 1, Template 3
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="settings.podcast_month"
                label="Mois et année"
                placeholder="octobre 2025"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="saving" @click="saveSettings">
          <v-icon left>{{ icons.mdiContentSave }}</v-icon>
          Enregistrer
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Info card about Digital -->
    <v-card class="mt-4">
      <v-card-title>
        <v-icon left color="info">{{ icons.mdiInformation }}</v-icon>
        <span>Médiamétrie//NetRatings (DIGITAL)</span>
      </v-card-title>
      <v-card-text>
        <p>
          La source DIGITAL est générée automatiquement à partir du champ
          <strong>digital_month_data</strong> de chaque marque.
        </p>
        <p class="mb-0">
          Le système affiche les 3 derniers mois se terminant par le mois
          indiqué dans les données de la marque (ex: "août OU septembre OU
          octobre 2025").
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiContentSave, mdiInformation } from "@mdi/js";
import { SOCIAL_SOURCE_LABEL } from "@/views/marketing/constants/index";

export default {
  name: "SourceSettings",
  data() {
    return {
      SOCIAL_SOURCE_LABEL,
      settings: {
        onenext_global_year: "",
        onenext_global_semester: "",
        onenext_year: "",
        onenext_semester: "",
        ojd_dfp_year_range: "",
        social_index_month: "",
        newsletter_month: "",
        podcast_month: "",
      },
      semesters: ["S1", "S2"],
      saving: false,
      icons: {
        mdiContentSave,
        mdiInformation,
      },
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const data = await this.$store.dispatch(
          "marketing/fetchSourceSettings"
        );
        if (data) {
          this.settings = {
            onenext_global_year: data.onenext_global_year || "",
            onenext_global_semester: data.onenext_global_semester || "",
            onenext_year: data.onenext_year || "",
            onenext_semester: data.onenext_semester || "",
            ojd_dfp_year_range: data.ojd_dfp_year_range || "",
            social_index_month: data.social_index_month || "",
            newsletter_month: data.newsletter_month || "",
            podcast_month: data.podcast_month || "",
          };
        }
      } catch (error) {
        this.$store.dispatch("app/setSnackBar", {
          show: true,
          text: "Erreur lors du chargement des paramètres: " + error.message,
          color: "error",
          timeout: 5000,
        });
      }
    },
    async saveSettings() {
      this.saving = true;
      try {
        await this.$store.dispatch(
          "marketing/updateSourceSettings",
          this.settings
        );
        this.$store.dispatch("app/setSnackBar", {
          show: true,
          text: "Paramètres enregistrés avec succès",
          color: "success",
          timeout: 3000,
        });
      } catch (error) {
        this.$store.dispatch("app/setSnackBar", {
          show: true,
          text: "Erreur lors de l'enregistrement: " + error.message,
          color: "error",
          timeout: 5000,
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
